import { AssessmentScenarioData } from '../../../../../types/assessments';
import { FieldRules, rules, runRules, ValidatedJsonType, ValidationResult } from '../validator';

export function isScenarioJson(value: ValidatedJsonType): ValidationResult {
	const json = value as AssessmentScenarioData;

	const fields: FieldRules[] = [
		{ key: 'name', actual: json.name, rules: [rules.isString(json.name)] },
		{
			key: 'blue_headstart',
			actual: json.blue_headstart,
			rules: [rules.isNumber(json.blue_headstart)],
		},
		{
			key: 'blue_force_package',
			actual: json.blue_force_package,
			rules: [rules.isNumber(json.blue_force_package)],
		},
		{
			key: 'red_force_package',
			actual: json.red_force_package,
			rules: [rules.isNumber(json.red_force_package)],
		},
		{ key: 'geography', actual: json.geography, rules: [rules.isString(json.geography)] },
		{ key: 'resolution', actual: json.resolution, rules: [rules.isString(json.resolution)] },
		{ key: 'mission', actual: json.mission, rules: [rules.isString(json.mission)] },
		{
			key: 'crossborder_blue',
			actual: json.crossborder_blue,
			rules: [rules.isBoolean(json.crossborder_blue)],
		},
		{
			key: 'rcs_calculation',
			actual: json.rcs_calculation,
			rules: [rules.isBoolean(json.rcs_calculation)],
		},
		{
			key: 'confounders',
			actual: json.confounders,
			rules: [
				rules.isArray(json.confounders),
				rules.everyItem(
					json.confounders,
					'every confounder must be a non-null object',
					(c: any) => typeof c === 'object' && c !== null
				),
			],
		},
		{
			key: 'target_selection',
			actual: json.target_selection,
			rules: [
				rules.custom(
					'must be "centralized" or "selfAssigned"',
					() =>
						json.target_selection === 'centralized' ||
						json.target_selection === 'selfAssigned'
				),
			],
		},
		{
			key: 'scenario_events',
			actual: json.scenario_events,
			rules: [
				rules.custom(
					'must be an array or null',
					() => Array.isArray(json.scenario_events) || json.scenario_events === null
				),
			],
		},
		{
			key: 'event_variability',
			actual: json.event_variability,
			rules: [rules.isNumber(json.event_variability)],
		},
		{
			key: 'bandwidth_limitations',
			actual: json.bandwidth_limitations,
			rules: [rules.isBoolean(json.bandwidth_limitations)],
		},
		{
			key: 'zones',
			actual: json.zones,
			rules: [
				rules.isArray(json.zones),
				rules.everyItem(
					json.zones,
					'every zone must be a number',
					(z: any) => typeof z === 'number'
				),
			],
		},
		{ key: 'id', actual: json.id, rules: [rules.optional(json.id, rules.isNumber(json.id))] },
		{
			key: 'blue_behavior_settings',
			actual: json.blue_behavior_settings,
			rules: [
				rules.isObject(json.blue_behavior_settings),
				rules.custom(
					'every value must be an array',
					() =>
						typeof json.blue_behavior_settings === 'object' &&
						json.blue_behavior_settings !== null &&
						Object.values(json.blue_behavior_settings).every((b: any) =>
							Array.isArray(b)
						)
				),
			],
		},
		{
			key: 'red_behavior_settings',
			actual: json.red_behavior_settings,
			rules: [
				rules.isObject(json.red_behavior_settings),
				rules.custom(
					'every value must be an array',
					() =>
						typeof json.red_behavior_settings === 'object' &&
						json.red_behavior_settings !== null &&
						Object.values(json.red_behavior_settings).every((b: any) =>
							Array.isArray(b)
						)
				),
			],
		},
	];

	return runRules(fields);
}

export const validateScenario = (data: ValidatedJsonType): ValidationResult => {
	return isScenarioJson(data);
};
